import { Fragment } from 'react';
import { formatDate } from '../utils/date';

const ClassicStatistics = (): JSX.Element => {
    const stats = JSON.parse(localStorage.getItem('classic') || '{}');
    const sizes = [3, 4, 5, 6, 7, 8];

    return (
        <div className="score-container">
            <div className="row header">
                <div className="cell">Size</div>
                <div className="cell">Fastest Time</div>
                <div className="cell">Fewest Moves</div>
            </div>
            {sizes.map(k => (
                <Fragment key={k}>
                    {stats[k] && <div className="row">
                        <div className="cell">{k} x {k}</div>
                        <div className="cell">{formatDate(stats[k].time)}</div>
                        <div className="cell">{stats[k].turns}</div>
                    </div>}
                </Fragment>
            ))}
        </div>
    );
}

export default ClassicStatistics;
